import ApiRoutes from "../../../../constants/api-routes";
import { hneAdminApi } from "../../../../service";

export const createNewMenus = async (body) =>
  hneAdminApi.post(`${ApiRoutes.CREATE_MENUS}`, body);

export const getAllMenus = async () =>
  hneAdminApi.get(`${ApiRoutes.GET_ALL_MENUS}`);

export const updateMenu = async (body, menu_id) =>
  hneAdminApi.put(`${ApiRoutes.UPDATE_MENU}/${menu_id}`, body);
